import { render, staticRenderFns } from "./content-item-details-modal.vue?vue&type=template&id=71ce3e63&scoped=true"
import script from "./content-item-details-modal.vue?vue&type=script&lang=js"
export * from "./content-item-details-modal.vue?vue&type=script&lang=js"
import style0 from "./content-item-details-modal.vue?vue&type=style&index=0&id=71ce3e63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ce3e63",
  null
  
)

export default component.exports